import { z } from '../zod.js';

export function PaginatedListSchema<T extends z.ZodTypeAny>(itemSchema: T) {
  return z.object({
    data: z.array(itemSchema),
    total: z
      .number()
      .meta({ description: 'Total number of records matching the query across all pages.' }),
    has_more: z
      .boolean()
      .meta({ description: 'Whether more records exist beyond the current page.' }),
  });
}
